import { useAxiosCreate } from '@/backend/utils.js';

const api = useAxiosCreate('admin');
const tmsApi = useAxiosCreate('tms');

function serializeParams(params) {
  const search = new URLSearchParams();
  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return;
    search.append(key, String(value));
  });
  return search.toString();
}

const PARAMS_SERIALIZER = { serialize: serializeParams };

export function fetchTmsActionLog(params = {}) {
  return api
    .get('tms-action-log', { params, paramsSerializer: PARAMS_SERIALIZER })
    .then((res) => res.data);
}

export function fetchTmsActionTimeline(cargoTripId, params = {}) {
  return api
    .get(`tms-action-log/${encodeURIComponent(cargoTripId)}`, {
      params,
      paramsSerializer: PARAMS_SERIALIZER,
    })
    .then((res) => res.data);
}

export function fetchTmsLastErrorByTrip(tripId) {
  return tmsApi
    .get(`action-log/by-trip/${encodeURIComponent(tripId)}/last-error`)
    .then((res) => res.data || null);
}

export function fetchTmsActionLogByExecutor(executorId, params = {}) {
  return tmsApi
    .get(`action-log/by-executor/${encodeURIComponent(executorId)}`, {
      params,
      paramsSerializer: PARAMS_SERIALIZER,
    })
    .then((res) => res.data);
}
